/**
 * Generated by orval 🍺
 * Do not edit manually.
 * API Vila Contábil
 * OpenAPI spec version: v1.0.9
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  AuthChangeAvatarBody,
  AuthConfirmRequest,
  AuthConfirmResponse,
  AuthConfirmUserEmailRequest,
  AuthEmailChangeConfirm,
  AuthEmailChangeRequest,
  AuthGetMyRelationsParams,
  AuthLogin,
  AuthPasswordUserPasswordRequest,
  AuthPasswordUserPasswordUpdateRequest,
  AuthRegister,
  AuthSwitchTenantParams,
  AuthUserAuthenticated,
  RelationShipDataDTO,
  UserDetailDTO,
  UserEdit
} from '../../model';

import { apiRequest } from '../../../mutator';
import type { ErrorType , BodyType } from '../../../mutator';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

/**
 * @summary Confirmar o e-mail com o código recebido
 */
export const authConfirmEmailCode = (
    authConfirmUserEmailRequest: BodyType<AuthConfirmUserEmailRequest>,
 options?: SecondParameter<typeof apiRequest>,signal?: AbortSignal
) => {


      return apiRequest<AuthConfirmResponse>(
      {url: `/auth/email/confirm`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: authConfirmUserEmailRequest, signal
    },
      options);
    }




export const getAuthConfirmEmailCodeMutationKey = () => ['authConfirmEmailCode'] as const;

export const getAuthConfirmEmailCodeMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authConfirmEmailCode>>, TError,AuthConfirmEmailCodeMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof authConfirmEmailCode>>, TError,AuthConfirmEmailCodeMutationVariables, TContext> => {

const mutationKey = getAuthConfirmEmailCodeMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof authConfirmEmailCode>>, AuthConfirmEmailCodeMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  authConfirmEmailCode(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AuthConfirmEmailCodeMutationResult = NonNullable<Awaited<ReturnType<typeof authConfirmEmailCode>>>
    export type AuthConfirmEmailCodeMutationBody = BodyType<AuthConfirmUserEmailRequest>
    export type AuthConfirmEmailCodeMutationError = ErrorType<void>
    export type AuthConfirmEmailCodeMutationVariables = {data: BodyType<AuthConfirmUserEmailRequest>}

    /**
 * @summary Confirmar o e-mail com o código recebido
 */
export const useAuthConfirmEmailCode = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authConfirmEmailCode>>, TError,AuthConfirmEmailCodeMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof authConfirmEmailCode>>,
        TError,
        AuthConfirmEmailCodeMutationVariables,
        TContext
      > => {
      return useMutation(getAuthConfirmEmailCodeMutationOptions(options), queryClient);
    }
    /**
 * @summary Reenviar o código de confirmação por e-mail
 */
export const authResendEmailCode = (
    authConfirmRequest: BodyType<AuthConfirmRequest>,
 options?: SecondParameter<typeof apiRequest>,signal?: AbortSignal
) => {


      return apiRequest<AuthConfirmResponse>(
      {url: `/auth/email/resend`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: authConfirmRequest, signal
    },
      options);
    }




export const getAuthResendEmailCodeMutationKey = () => ['authResendEmailCode'] as const;

export const getAuthResendEmailCodeMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authResendEmailCode>>, TError,AuthResendEmailCodeMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof authResendEmailCode>>, TError,AuthResendEmailCodeMutationVariables, TContext> => {

const mutationKey = getAuthResendEmailCodeMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof authResendEmailCode>>, AuthResendEmailCodeMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  authResendEmailCode(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AuthResendEmailCodeMutationResult = NonNullable<Awaited<ReturnType<typeof authResendEmailCode>>>
    export type AuthResendEmailCodeMutationBody = BodyType<AuthConfirmRequest>
    export type AuthResendEmailCodeMutationError = ErrorType<void>
    export type AuthResendEmailCodeMutationVariables = {data: BodyType<AuthConfirmRequest>}

    /**
 * @summary Reenviar o código de confirmação por e-mail
 */
export const useAuthResendEmailCode = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authResendEmailCode>>, TError,AuthResendEmailCodeMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof authResendEmailCode>>,
        TError,
        AuthResendEmailCodeMutationVariables,
        TContext
      > => {
      return useMutation(getAuthResendEmailCodeMutationOptions(options), queryClient);
    }
    /**
 * Usado no primeiro acesso (conta criada pelo escritório): confirma o código e ativa o login.
 * @summary Ativar a conta com o código do e-mail
 */
export const authActivateEmail = (
    authConfirmUserEmailRequest: BodyType<AuthConfirmUserEmailRequest>,
 options?: SecondParameter<typeof apiRequest>,signal?: AbortSignal
) => {


      return apiRequest<AuthConfirmResponse>(
      {url: `/auth/email/activate`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: authConfirmUserEmailRequest, signal
    },
      options);
    }




export const getAuthActivateEmailMutationKey = () => ['authActivateEmail'] as const;

export const getAuthActivateEmailMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authActivateEmail>>, TError,AuthActivateEmailMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof authActivateEmail>>, TError,AuthActivateEmailMutationVariables, TContext> => {

const mutationKey = getAuthActivateEmailMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof authActivateEmail>>, AuthActivateEmailMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  authActivateEmail(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AuthActivateEmailMutationResult = NonNullable<Awaited<ReturnType<typeof authActivateEmail>>>
    export type AuthActivateEmailMutationBody = BodyType<AuthConfirmUserEmailRequest>
    export type AuthActivateEmailMutationError = ErrorType<void>
    export type AuthActivateEmailMutationVariables = {data: BodyType<AuthConfirmUserEmailRequest>}

    /**
 * @summary Ativar a conta com o código do e-mail
 */
export const useAuthActivateEmail = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authActivateEmail>>, TError,AuthActivateEmailMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof authActivateEmail>>,
        TError,
        AuthActivateEmailMutationVariables,
        TContext
      > => {
      return useMutation(getAuthActivateEmailMutationOptions(options), queryClient);
    }
    /**
 * @summary Cadastrar usuário (criar conta)
 */
export const authRegister = (
    authRegisterBody: BodyType<AuthRegister>,
 options?: SecondParameter<typeof apiRequest>,signal?: AbortSignal
) => {


      return apiRequest<string>(
      {url: `/auth/register`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: authRegisterBody, signal
    },
      options);
    }




export const getAuthRegisterMutationKey = () => ['authRegister'] as const;

export const getAuthRegisterMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authRegister>>, TError,AuthRegisterMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof authRegister>>, TError,AuthRegisterMutationVariables, TContext> => {

const mutationKey = getAuthRegisterMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof authRegister>>, AuthRegisterMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  authRegister(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AuthRegisterMutationResult = NonNullable<Awaited<ReturnType<typeof authRegister>>>
    export type AuthRegisterMutationBody = BodyType<AuthRegister>
    export type AuthRegisterMutationError = ErrorType<void>
    export type AuthRegisterMutationVariables = {data: BodyType<AuthRegister>}

    /**
 * @summary Cadastrar usuário (criar conta)
 */
export const useAuthRegister = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authRegister>>, TError,AuthRegisterMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof authRegister>>,
        TError,
        AuthRegisterMutationVariables,
        TContext
      > => {
      return useMutation(getAuthRegisterMutationOptions(options), queryClient);
    }
    /**
 * Devolve o token JWT e o escritório/perfil do último acesso. Credenciais erradas ou conta inativa → 401/400 com mensagem.
 * @summary Entrar no sistema
 */
export const authLogin = (
    authLoginBody: BodyType<AuthLogin>,
 options?: SecondParameter<typeof apiRequest>,signal?: AbortSignal
) => {


      return apiRequest<AuthUserAuthenticated>(
      {url: `/auth/login`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: authLoginBody, signal
    },
      options);
    }




export const getAuthLoginMutationKey = () => ['authLogin'] as const;

export const getAuthLoginMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authLogin>>, TError,AuthLoginMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof authLogin>>, TError,AuthLoginMutationVariables, TContext> => {

const mutationKey = getAuthLoginMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof authLogin>>, AuthLoginMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  authLogin(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AuthLoginMutationResult = NonNullable<Awaited<ReturnType<typeof authLogin>>>
    export type AuthLoginMutationBody = BodyType<AuthLogin>
    export type AuthLoginMutationError = ErrorType<void>
    export type AuthLoginMutationVariables = {data: BodyType<AuthLogin>}

    /**
 * @summary Entrar no sistema
 */
export const useAuthLogin = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authLogin>>, TError,AuthLoginMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof authLogin>>,
        TError,
        AuthLoginMutationVariables,
        TContext
      > => {
      return useMutation(getAuthLoginMutationOptions(options), queryClient);
    }
    /**
 * Gera um token novo para o escritório `tenantId` e o perfil `relationType` (Proprietário, Funcionário, Cliente, Declarante). Sem relação ativa → 403.
 * @summary Trocar de escritório ou perfil
 */
export const authSwitchTenant = (
    tenantId: number,
    params?: AuthSwitchTenantParams,
 options?: SecondParameter<typeof apiRequest>,signal?: AbortSignal
) => {


      return apiRequest<AuthUserAuthenticated>(
      {url: `/auth/switch/${tenantId}`, method: 'PUT',
        params, signal
    },
      options);
    }




export const getAuthSwitchTenantMutationKey = () => ['authSwitchTenant'] as const;

export const getAuthSwitchTenantMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authSwitchTenant>>, TError,AuthSwitchTenantMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof authSwitchTenant>>, TError,AuthSwitchTenantMutationVariables, TContext> => {

const mutationKey = getAuthSwitchTenantMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof authSwitchTenant>>, AuthSwitchTenantMutationVariables> = (props) => {
          const {tenantId,params} = props ?? {};

          return  authSwitchTenant(tenantId,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AuthSwitchTenantMutationResult = NonNullable<Awaited<ReturnType<typeof authSwitchTenant>>>

    export type AuthSwitchTenantMutationError = ErrorType<void>
    export type AuthSwitchTenantMutationVariables = {tenantId: number;params?: AuthSwitchTenantParams}

    /**
 * @summary Trocar de escritório ou perfil
 */
export const useAuthSwitchTenant = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authSwitchTenant>>, TError,AuthSwitchTenantMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof authSwitchTenant>>,
        TError,
        AuthSwitchTenantMutationVariables,
        TContext
      > => {
      return useMutation(getAuthSwitchTenantMutationOptions(options), queryClient);
    }
    /**
 * Envia um código para o e-mail novo; a troca só vale depois de confirmar.
 * @summary Pedir troca do e-mail de acesso
 */
export const authRequestEmailChange = (
    authEmailChangeRequest: BodyType<AuthEmailChangeRequest>,
 options?: SecondParameter<typeof apiRequest>,signal?: AbortSignal
) => {


      return apiRequest<void>(
      {url: `/auth/email/change`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: authEmailChangeRequest, signal
    },
      options);
    }




export const getAuthRequestEmailChangeMutationKey = () => ['authRequestEmailChange'] as const;

export const getAuthRequestEmailChangeMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authRequestEmailChange>>, TError,AuthRequestEmailChangeMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof authRequestEmailChange>>, TError,AuthRequestEmailChangeMutationVariables, TContext> => {

const mutationKey = getAuthRequestEmailChangeMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof authRequestEmailChange>>, AuthRequestEmailChangeMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  authRequestEmailChange(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AuthRequestEmailChangeMutationResult = NonNullable<Awaited<ReturnType<typeof authRequestEmailChange>>>
    export type AuthRequestEmailChangeMutationBody = BodyType<AuthEmailChangeRequest>
    export type AuthRequestEmailChangeMutationError = ErrorType<void>
    export type AuthRequestEmailChangeMutationVariables = {data: BodyType<AuthEmailChangeRequest>}

    /**
 * @summary Pedir troca do e-mail de acesso
 */
export const useAuthRequestEmailChange = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authRequestEmailChange>>, TError,AuthRequestEmailChangeMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof authRequestEmailChange>>,
        TError,
        AuthRequestEmailChangeMutationVariables,
        TContext
      > => {
      return useMutation(getAuthRequestEmailChangeMutationOptions(options), queryClient);
    }
    /**
 * @summary Confirmar a troca do e-mail de acesso
 */
export const authConfirmEmailChange = (
    authEmailChangeConfirm: BodyType<AuthEmailChangeConfirm>,
 options?: SecondParameter<typeof apiRequest>,signal?: AbortSignal
) => {


      return apiRequest<void>(
      {url: `/auth/email/change/confirm`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: authEmailChangeConfirm, signal
    },
      options);
    }




export const getAuthConfirmEmailChangeMutationKey = () => ['authConfirmEmailChange'] as const;

export const getAuthConfirmEmailChangeMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authConfirmEmailChange>>, TError,AuthConfirmEmailChangeMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof authConfirmEmailChange>>, TError,AuthConfirmEmailChangeMutationVariables, TContext> => {

const mutationKey = getAuthConfirmEmailChangeMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof authConfirmEmailChange>>, AuthConfirmEmailChangeMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  authConfirmEmailChange(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AuthConfirmEmailChangeMutationResult = NonNullable<Awaited<ReturnType<typeof authConfirmEmailChange>>>
    export type AuthConfirmEmailChangeMutationBody = BodyType<AuthEmailChangeConfirm>
    export type AuthConfirmEmailChangeMutationError = ErrorType<void>
    export type AuthConfirmEmailChangeMutationVariables = {data: BodyType<AuthEmailChangeConfirm>}

    /**
 * @summary Confirmar a troca do e-mail de acesso
 */
export const useAuthConfirmEmailChange = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authConfirmEmailChange>>, TError,AuthConfirmEmailChangeMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof authConfirmEmailChange>>,
        TError,
        AuthConfirmEmailChangeMutationVariables,
        TContext
      > => {
      return useMutation(getAuthConfirmEmailChangeMutationOptions(options), queryClient);
    }
    /**
 * Filtros opcionais por escritório e por perfil.
 * @summary Listar os acessos (escritórios e perfis) do usuário logado
 */
export const authGetMyRelations = (
    params?: AuthGetMyRelationsParams,
 options?: SecondParameter<typeof apiRequest>,signal?: AbortSignal
) => {


      return apiRequest<RelationShipDataDTO[]>(
      {url: `/auth/me/relations`, method: 'GET',
        params, signal
    },
      options);
    }




export const getAuthGetMyRelationsQueryKey = (params?: AuthGetMyRelationsParams,) => {
    return [
    `/auth/me/relations`, ...(params ? [params] : [])
    ] as const;
    }


export const getAuthGetMyRelationsQueryOptions = <TData = Awaited<ReturnType<typeof authGetMyRelations>>, TError = ErrorType<void>>(params?: AuthGetMyRelationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof authGetMyRelations>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAuthGetMyRelationsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof authGetMyRelations>>> = ({ signal }) => authGetMyRelations(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof authGetMyRelations>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AuthGetMyRelationsQueryResult = NonNullable<Awaited<ReturnType<typeof authGetMyRelations>>>
export type AuthGetMyRelationsQueryError = ErrorType<void>


export function useAuthGetMyRelations<TData = Awaited<ReturnType<typeof authGetMyRelations>>, TError = ErrorType<void>>(
 params: undefined |  AuthGetMyRelationsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof authGetMyRelations>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof authGetMyRelations>>,
          TError,
          Awaited<ReturnType<typeof authGetMyRelations>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAuthGetMyRelations<TData = Awaited<ReturnType<typeof authGetMyRelations>>, TError = ErrorType<void>>(
 params?: AuthGetMyRelationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof authGetMyRelations>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof authGetMyRelations>>,
          TError,
          Awaited<ReturnType<typeof authGetMyRelations>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAuthGetMyRelations<TData = Awaited<ReturnType<typeof authGetMyRelations>>, TError = ErrorType<void>>(
 params?: AuthGetMyRelationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof authGetMyRelations>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Listar os acessos (escritórios e perfis) do usuário logado
 */

export function useAuthGetMyRelations<TData = Awaited<ReturnType<typeof authGetMyRelations>>, TError = ErrorType<void>>(
 params?: AuthGetMyRelationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof authGetMyRelations>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAuthGetMyRelationsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Consultar o usuário logado
 */
export const authGetMe = (

 options?: SecondParameter<typeof apiRequest>,signal?: AbortSignal
) => {


      return apiRequest<UserDetailDTO>(
      {url: `/auth/me`, method: 'GET', signal
    },
      options);
    }




export const getAuthGetMeQueryKey = () => {
    return [
    `/auth/me`
    ] as const;
    }


export const getAuthGetMeQueryOptions = <TData = Awaited<ReturnType<typeof authGetMe>>, TError = ErrorType<void>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof authGetMe>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAuthGetMeQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof authGetMe>>> = ({ signal }) => authGetMe(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof authGetMe>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AuthGetMeQueryResult = NonNullable<Awaited<ReturnType<typeof authGetMe>>>
export type AuthGetMeQueryError = ErrorType<void>


export function useAuthGetMe<TData = Awaited<ReturnType<typeof authGetMe>>, TError = ErrorType<void>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof authGetMe>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof authGetMe>>,
          TError,
          Awaited<ReturnType<typeof authGetMe>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAuthGetMe<TData = Awaited<ReturnType<typeof authGetMe>>, TError = ErrorType<void>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof authGetMe>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof authGetMe>>,
          TError,
          Awaited<ReturnType<typeof authGetMe>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAuthGetMe<TData = Awaited<ReturnType<typeof authGetMe>>, TError = ErrorType<void>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof authGetMe>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Consultar o usuário logado
 */

export function useAuthGetMe<TData = Awaited<ReturnType<typeof authGetMe>>, TError = ErrorType<void>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof authGetMe>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAuthGetMeQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Alterar os dados do usuário logado
 */
export const authUpdateMe = (
    userEdit: BodyType<UserEdit>,
 options?: SecondParameter<typeof apiRequest>,signal?: AbortSignal
) => {


      return apiRequest<UserDetailDTO>(
      {url: `/auth/me`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: userEdit, signal
    },
      options);
    }




export const getAuthUpdateMeMutationKey = () => ['authUpdateMe'] as const;

export const getAuthUpdateMeMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authUpdateMe>>, TError,AuthUpdateMeMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof authUpdateMe>>, TError,AuthUpdateMeMutationVariables, TContext> => {

const mutationKey = getAuthUpdateMeMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof authUpdateMe>>, AuthUpdateMeMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  authUpdateMe(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AuthUpdateMeMutationResult = NonNullable<Awaited<ReturnType<typeof authUpdateMe>>>
    export type AuthUpdateMeMutationBody = BodyType<UserEdit>
    export type AuthUpdateMeMutationError = ErrorType<void>
    export type AuthUpdateMeMutationVariables = {data: BodyType<UserEdit>}

    /**
 * @summary Alterar os dados do usuário logado
 */
export const useAuthUpdateMe = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authUpdateMe>>, TError,AuthUpdateMeMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof authUpdateMe>>,
        TError,
        AuthUpdateMeMutationVariables,
        TContext
      > => {
      return useMutation(getAuthUpdateMeMutationOptions(options), queryClient);
    }
    /**
 * @summary Trocar a foto do usuário logado
 */
export const authChangeAvatar = (
    authChangeAvatarBody: BodyType<AuthChangeAvatarBody>,
 options?: SecondParameter<typeof apiRequest>,signal?: AbortSignal
) => {

      const formData = new FormData();
formData.append(`Image`, authChangeAvatarBody.Image);

      return apiRequest<void>(
      {url: `/auth/me/avatar`, method: 'PUT',
      headers: {'Content-Type': 'multipart/form-data', },
       data: formData, signal
    },
      options);
    }




export const getAuthChangeAvatarMutationKey = () => ['authChangeAvatar'] as const;

export const getAuthChangeAvatarMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authChangeAvatar>>, TError,AuthChangeAvatarMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof authChangeAvatar>>, TError,AuthChangeAvatarMutationVariables, TContext> => {

const mutationKey = getAuthChangeAvatarMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof authChangeAvatar>>, AuthChangeAvatarMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  authChangeAvatar(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AuthChangeAvatarMutationResult = NonNullable<Awaited<ReturnType<typeof authChangeAvatar>>>
    export type AuthChangeAvatarMutationBody = BodyType<AuthChangeAvatarBody>
    export type AuthChangeAvatarMutationError = ErrorType<void>
    export type AuthChangeAvatarMutationVariables = {data: BodyType<AuthChangeAvatarBody>}

    /**
 * @summary Trocar a foto do usuário logado
 */
export const useAuthChangeAvatar = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authChangeAvatar>>, TError,AuthChangeAvatarMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof authChangeAvatar>>,
        TError,
        AuthChangeAvatarMutationVariables,
        TContext
      > => {
      return useMutation(getAuthChangeAvatarMutationOptions(options), queryClient);
    }
    /**
 * @summary Criar a senha (primeiro acesso)
 */
export const authCreatePassword = (
    authPasswordUserPasswordRequest: BodyType<AuthPasswordUserPasswordRequest>,
 options?: SecondParameter<typeof apiRequest>,signal?: AbortSignal
) => {


      return apiRequest<AuthConfirmResponse>(
      {url: `/auth/password/create`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: authPasswordUserPasswordRequest, signal
    },
      options);
    }




export const getAuthCreatePasswordMutationKey = () => ['authCreatePassword'] as const;

export const getAuthCreatePasswordMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authCreatePassword>>, TError,AuthCreatePasswordMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof authCreatePassword>>, TError,AuthCreatePasswordMutationVariables, TContext> => {

const mutationKey = getAuthCreatePasswordMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof authCreatePassword>>, AuthCreatePasswordMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  authCreatePassword(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AuthCreatePasswordMutationResult = NonNullable<Awaited<ReturnType<typeof authCreatePassword>>>
    export type AuthCreatePasswordMutationBody = BodyType<AuthPasswordUserPasswordRequest>
    export type AuthCreatePasswordMutationError = ErrorType<void>
    export type AuthCreatePasswordMutationVariables = {data: BodyType<AuthPasswordUserPasswordRequest>}

    /**
 * @summary Criar a senha (primeiro acesso)
 */
export const useAuthCreatePassword = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authCreatePassword>>, TError,AuthCreatePasswordMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof authCreatePassword>>,
        TError,
        AuthCreatePasswordMutationVariables,
        TContext
      > => {
      return useMutation(getAuthCreatePasswordMutationOptions(options), queryClient);
    }
    /**
 * @summary Trocar a senha do usuário logado
 */
export const authUpdatePassword = (
    authPasswordUserPasswordUpdateRequest: BodyType<AuthPasswordUserPasswordUpdateRequest>,
 options?: SecondParameter<typeof apiRequest>,signal?: AbortSignal
) => {


      return apiRequest<void>(
      {url: `/auth/password/update`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: authPasswordUserPasswordUpdateRequest, signal
    },
      options);
    }




export const getAuthUpdatePasswordMutationKey = () => ['authUpdatePassword'] as const;

export const getAuthUpdatePasswordMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authUpdatePassword>>, TError,AuthUpdatePasswordMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof authUpdatePassword>>, TError,AuthUpdatePasswordMutationVariables, TContext> => {

const mutationKey = getAuthUpdatePasswordMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof authUpdatePassword>>, AuthUpdatePasswordMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  authUpdatePassword(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AuthUpdatePasswordMutationResult = NonNullable<Awaited<ReturnType<typeof authUpdatePassword>>>
    export type AuthUpdatePasswordMutationBody = BodyType<AuthPasswordUserPasswordUpdateRequest>
    export type AuthUpdatePasswordMutationError = ErrorType<void>
    export type AuthUpdatePasswordMutationVariables = {data: BodyType<AuthPasswordUserPasswordUpdateRequest>}

    /**
 * @summary Trocar a senha do usuário logado
 */
export const useAuthUpdatePassword = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authUpdatePassword>>, TError,AuthUpdatePasswordMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof authUpdatePassword>>,
        TError,
        AuthUpdatePasswordMutationVariables,
        TContext
      > => {
      return useMutation(getAuthUpdatePasswordMutationOptions(options), queryClient);
    }
    /**
 * @summary Esqueci a senha: enviar código de redefinição
 */
export const authForgotPassword = (
    authConfirmRequest: BodyType<AuthConfirmRequest>,
 options?: SecondParameter<typeof apiRequest>,signal?: AbortSignal
) => {


      return apiRequest<AuthConfirmResponse>(
      {url: `/auth/password/forgot`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: authConfirmRequest, signal
    },
      options);
    }




export const getAuthForgotPasswordMutationKey = () => ['authForgotPassword'] as const;

export const getAuthForgotPasswordMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authForgotPassword>>, TError,AuthForgotPasswordMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof authForgotPassword>>, TError,AuthForgotPasswordMutationVariables, TContext> => {

const mutationKey = getAuthForgotPasswordMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof authForgotPassword>>, AuthForgotPasswordMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  authForgotPassword(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AuthForgotPasswordMutationResult = NonNullable<Awaited<ReturnType<typeof authForgotPassword>>>
    export type AuthForgotPasswordMutationBody = BodyType<AuthConfirmRequest>
    export type AuthForgotPasswordMutationError = ErrorType<void>
    export type AuthForgotPasswordMutationVariables = {data: BodyType<AuthConfirmRequest>}

    /**
 * @summary Esqueci a senha: enviar código de redefinição
 */
export const useAuthForgotPassword = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authForgotPassword>>, TError,AuthForgotPasswordMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof authForgotPassword>>,
        TError,
        AuthForgotPasswordMutationVariables,
        TContext
      > => {
      return useMutation(getAuthForgotPasswordMutationOptions(options), queryClient);
    }
